import React from "react";
import DataSubmissionHelp from "./DataSubmissionHelp";

const DataSubmissionHeader = (props) => {
  const SUBMISSION_TYPE_LABELS = {
    pharmacy: "Pharmacy",
    medical: "Medical",
    pharmacy_encounter: "Pharmacy Encounter",
    medical_encounter: "Medical Encounter",
  };
  const vanitySubmissionType = SUBMISSION_TYPE_LABELS[props.submissionType] || props.submissionType;

  return (
    <div className="page-details__container">
      <div className="page-details__container__info">
        <div className="flex justify-content-between align-items-start">
          <div>
            <div className="breadcrumbs__container">
              <div className="breadcrumbs__crumb">{`${vanitySubmissionType} Claims Data >`}</div>
              <div className="breadcrumbs__crumb breadcrumbs__crumb__active">New</div>
            </div>
            <div className="page-details__title">{`Submit 340B ${vanitySubmissionType} Claims Data`}</div>
          </div>
          <DataSubmissionHelp ndcDownloadPath={props.ndcDownloadPath} />
        </div>
      </div>
    </div>
  );
};

export default DataSubmissionHeader;
